import * as React from 'react';
import { cn } from '../../lib/cn';

export interface KbdProps extends React.HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode;
}

export function Kbd({ className, children, ...props }: KbdProps) {
  return (
    <span className={cn('kbd', className)} {...props}>
      {children}
    </span>
  );
}
